// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-10dcff46],\n.fade-leave-active[data-v-10dcff46] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-10dcff46], .fade-leave-to[data-v-10dcff46] {\n  opacity: 0;\n}\n.gogonghome[data-v-10dcff46] {\n  padding-top: 4px;\n}", ""]);
// Exports
module.exports = exports;
